package org.hs_soft.runmynesto.pages.home.sub_page.media_center.mvi

import kotlinx.coroutines.flow.MutableStateFlow
import kotlinx.coroutines.flow.StateFlow
import kotlinx.serialization.json.buildJsonObject
import kotlinx.serialization.json.put
import org.hs_soft.runmynesto.data.api_datasource.RequestManager
import org.hs_soft.runmynesto.domain.errorMessage

import org.hs_soft.runmynesto.domain.model.general.WindowSizeModeEnum
import org.hs_soft.runmynesto.domain.model.general_error_model.GeneralError
import org.hs_soft.runmynesto.domain.model.home.media_center.MediaCenterInfoHeaderEnum
import org.hs_soft.runmynesto.domain.model.home.media_center.tabs.media.media_model.MediaItem
import org.hs_soft.runmynesto.domain.model.home.media_center.tabs.media.media_tab.MediaTag
import org.hs_soft.runmynesto.domain.model.home.template.tabs.tab_general.calendar.MonthModel
import org.hs_soft.runmynesto.domain.model.home.user.tabs.user_checkout.user_checkout_model.Children
import org.hs_soft.runmynesto.domain.requestHandler
import org.hs_soft.runmynesto.domain.usecase.home.GetSavedCheckOutUseCase
import org.hs_soft.runmynesto.domain.usecase.home.GetSavedShopListUseCase
import org.hs_soft.runmynesto.domain.usecase.media_center.tabs.media.AddNewMediaUseCase
import org.hs_soft.runmynesto.domain.usecase.media_center.tabs.media.AddTagUseCase
import org.hs_soft.runmynesto.domain.usecase.media_center.tabs.media.DeleteTagUseCase
import org.hs_soft.runmynesto.domain.usecase.media_center.tabs.media.LoadAppConstantsUseCase
import org.hs_soft.runmynesto.domain.usecase.media_center.tabs.media.MediaDetailUseCase
import org.hs_soft.runmynesto.domain.usecase.media_center.tabs.media.MediaListUseCase
import org.hs_soft.runmynesto.domain.usecase.media_center.tabs.media.MediaTagsUseCase
import org.hs_soft.runmynesto.domain.usecase.media_center.tabs.media.UpdateBase64ImgUseCase
import org.hs_soft.runmynesto.domain.usecase.media_center.tabs.media.UpdateMediaUseCase
import org.hs_soft.runmynesto.domain.usecase.product.GetImgUrlUseCase
import org.hs_soft.runmynesto.domain.usecase.product.ProductCategoriesUseCase
import org.hs_soft.runmynesto.domain.usecase.product.tab_product_general.cache.GetCachedProductCategoriesUseCase
import org.hs_soft.runmynesto.domain.usecase.product.tab_product_general.cache.SaveCachedProductCategoriesUseCase
import org.hs_soft.runmynesto.domain.util.ApiUtils
import org.hs_soft.runmynesto.domain.util.IdUtils
import org.hs_soft.runmynesto.domain.util.helper.BaseViewModel
import org.hs_soft.runmynesto.domain.util.monthModelToDateString
import org.hs_soft.runmynesto.domain.util.withTokenRefresh
import org.hs_soft.runmynesto.pages.home.sub_page.closing_reports.mvi.ClosingReportsEvent

class MediaCenterViewModel(
    private val requestManager: RequestManager,
    private val getSavedCheckOutUseCase: GetSavedCheckOutUseCase,
    private val mediaListUseCase: MediaListUseCase,
    private val mediaDetailUseCase: MediaDetailUseCase,
    private val addNewMediaUseCase: AddNewMediaUseCase,
    private val mediaTagsUseCase: MediaTagsUseCase,
    private val updateMediaUseCase: UpdateMediaUseCase,
    private val imgUrlUseCase: GetImgUrlUseCase,
    private val updateBase64ImgUseCase: UpdateBase64ImgUseCase,
    private val getSavedShopListUseCase: GetSavedShopListUseCase,
    private val loadAppConstantsUseCase: LoadAppConstantsUseCase,
    private val deleteTagUseCase: DeleteTagUseCase,
    private val saveCachedProductCategoriesUseCase: SaveCachedProductCategoriesUseCase,
    private val productCategoriesUseCase: ProductCategoriesUseCase,
    private val addTagUseCase: AddTagUseCase,
    private val getCachedProductCategoriesUseCase: GetCachedProductCategoriesUseCase,
): BaseViewModel() {

    private val _state = MutableStateFlow(MediaCenterState())
    val state: StateFlow<MediaCenterState> = _state
    private var tempCheckoutList: List<Children>? = listOf()

    private var tempMediaItems:List<MediaItem> = listOf()

    override  fun clear() {
        super.clear()
        requestManager.cancelAll()
    }

    init {
        onEvent(MediaCenterEvent.GetAllProducts)
    }

    fun onEvent(event: MediaCenterEvent)
    {
        when(event){
            is MediaCenterEvent.DismissErrorDialog->{
                _state.value=_state.value.copy(
                    errorInfo = null,
                )
            }

            is MediaCenterEvent.UpdateCheckout->{
                updateMedia(
                    id=state.value.selectedMedia?.id?:"",
                    dataTitle = ApiUtils.Field.cashRegisterId,
                    dataValue=event.dataValue.toList(),
                    updateMediaType = ApiUtils.Type.updateMediaCashRegisters
                )

            }

            is MediaCenterEvent.OnSearchCheckoutItems->{
                searchCheckoutItems(value=event.value)
            }

            is MediaCenterEvent.DeleteArticle->{
                deleteArticle(id=event.id)
            }

            is MediaCenterEvent.AddItemToArticleList->{
                addArticle(id=event.id)
            }
            is MediaCenterEvent.SetArticleDialogStatus->{
                _state.value=_state.value.copy(
                    showArticleDialog = event.status,
                    addRecordErrorMessage = ""
                )
            }

            is MediaCenterEvent.GetAllProducts->{
                getAllProducts()
            }
            is MediaCenterEvent.SetDisplaySize->{
                _state.value=_state.value.copy(
                    selectedDisplaySize = event.displaySize
                )
            }

            is MediaCenterEvent.SetAddNewGroupDialogStatus->{
                _state.value=_state.value.copy(
                    showAddGroupDialog = event.status
                )
            }

            is MediaCenterEvent.DeleteTag->{
                deleteTag(
                    id=event.tagId
                )
            }
            is MediaCenterEvent.AddTag->{
                addTag(
                    name =event.name,
                )
            }

            is MediaCenterEvent.LoadAppConstants->{
                loadAppConstants()
            }
            is MediaCenterEvent.GetShopList->{
                getShopList()
            }
            is MediaCenterEvent.UpdateBase64Img->{
                updateBase64Img(
                    file=event.file,
                    type=event.type,
                    id=state.value.selectedMedia?.id?:""
                )
            }

            is MediaCenterEvent.OnSelectFromDate->{
                selectFromDate(
                    selectedDate = event.date
                )
            }
            is MediaCenterEvent.SetFromCalendarStatus->{
                setFromCalendarStatus(
                    status = event.status,
                )
            }
            is MediaCenterEvent.OnSelectToDate->{
                selectToDate(
                    selectedDate = event.date
                )
            }
            is MediaCenterEvent.SetToCalendarStatus->{
                setToCalendarStatus(status=event.status)
            }

            is MediaCenterEvent.UpdateMedia->{
                updateMedia(
                    id = state.value.selectedMedia?.id?:"",
                    dataTitle = event.title,
                    dataValue = event.value,
                    updateMediaType = ApiUtils.Field.updateMediaMain,
                )
            }
            is MediaCenterEvent.GetMediaTags->{
                getMediaTags()
            }
            is MediaCenterEvent.OnChangeRecordName->{
                onChangeRecordName(event.value)
            }
            is MediaCenterEvent.OnCancelRecordDialogClick->{
                dismissAddRecordDialog()
            }
            is MediaCenterEvent.OnSubmitRecordDialogClick->{
                onSubmitRecordDialogClick(
                    windowMode = event.screenMode,
                    name = state.value.newRecordName
                )
            }

            is MediaCenterEvent.OnChangePageClick->{
                _state.value=_state.value.copy(
                    firstPageActive = !state.value.firstPageActive
                )
            }
            is MediaCenterEvent.GetCheckoutData->{
                getCheckoutData()
            }
            is MediaCenterEvent.OnTopTabClick->{
                onTopTabClick(tab=event.tab)
            }
            is MediaCenterEvent.GetMediaList->{
                getMediaList(
                    isActive=state.value.selectedFilterItemsType.value
                )
            }

            is MediaCenterEvent.OnSearchMediaInputChange->{
                onSearchMediaInputChange(value = event.value)
            }
            is MediaCenterEvent.OnMediaItemClick->{
                onMediaItemClick(
                    id = event.id,
                    switchTheSecondPage =event.switchTheSecondPage
                )
            }
            is MediaCenterEvent.OnAddRecordIconClick->{
                onAddRecordIconClick()
            }
            is MediaCenterEvent.OnMainGridTitleSortClick->{
                onMainGridTitleSortClick()
            }
            is MediaCenterEvent.OnMainGridNumberSortClick->{
                onMainGridNumberSortClick()
            }
            is MediaCenterEvent.RefreshMediaCenterItems->{
                getMediaList(
                    isActive=state.value.mediaItemsIsActiveFilter
                )
            }
            is MediaCenterEvent.SetFilterItemsComponentStatus->{
                _state.value=_state.value.copy(
                    showItemsFilterComponent = event.status
                )
            }
            is MediaCenterEvent.SubmitFilterItems->{
                submitFilterMediaCenterItems()

            }
            is MediaCenterEvent.SelectFilterType->{
                _state.value=_state.value.copy(
                    selectedFilterItemsType = event.type
                )
            }


        }
    }

    private fun submitFilterMediaCenterItems() {
        _state.value=_state.value.copy(
            showItemsFilterComponent = false
        )
        getMediaList(
            isActive =state.value.selectedFilterItemsType.value
        )
    }


    private fun searchCheckoutItems(value: String) {
        if (value.isEmpty()) {
            _state.value = _state.value.copy(
                cashList = tempCheckoutList,
                isCheckoutExpandAll = false
            )
            return
        }

        val searchTerm = value.lowercase()
        val searchedList = tempCheckoutList?.mapNotNull { model ->
            val filteredChildrenX = model.children?.mapNotNull { childX ->
                val filteredChildrenXX = childX.children?.mapNotNull { childXX ->
                    val filteredChildrenXXX = childXX.children.filter { childXXX ->
                        childXXX.name?.lowercase()?.contains(searchTerm) == true
                    }

                    if (childXX.name?.lowercase()?.contains(searchTerm) == true || filteredChildrenXXX.isNotEmpty()) {
                        childXX.copy(children = filteredChildrenXXX)
                    } else null
                }

                if (childX.name?.lowercase()?.contains(searchTerm) == true || filteredChildrenXX?.isNotEmpty() == true) {
                    childX.copy(children = filteredChildrenXX)
                } else null
            }

            if (model.name?.lowercase()?.contains(searchTerm) == true || filteredChildrenX?.isNotEmpty() == true) {
                model.copy(children = filteredChildrenX)
            } else null
        }

        _state.value = _state.value.copy(
            cashList = searchedList,
            isCheckoutExpandAll = true
        )
    }


    private fun addArticle(id: String) {
        val productIds=state.value.selectedMedia?.withProducts?.map { it.id }
            ?.toMutableSet()

        productIds?.add(id)

        updateMedia(
            id=state.value.selectedMedia?.id?:"",
            dataTitle = ApiUtils.Field.productsId,
            dataValue = productIds?.toList(),
            updateMediaType = ApiUtils.Field.updateMediaMain,
        )

        _state.value=_state.value.copy(
            showArticleDialog = false
        )


    }

    private fun deleteArticle(
        id: String,
    ) {
        val productIds=state.value.selectedMedia?.withProducts?.map { it.id }
            ?.toMutableSet()

        productIds?.remove(id)
        console.log(id)
        console.log(productIds?.toList())
        updateMedia(
            id=state.value.selectedMedia?.id?:"",
            dataTitle = ApiUtils.Field.productsId,
            dataValue = productIds?.toList(),
            updateMediaType = ApiUtils.Field.updateMediaMain,
        )

        _state.value=_state.value.copy(
            showArticleDialog = false
        )
    }

    private fun getAllProducts() {
        if (state.value.allProducts == null) {
            getCachedProductCategoriesUseCase {
                if (it == null) {
                    launch {
                        requestHandler(
                            callRequest = {
                                productCategoriesUseCase()
                            },
                            onSuccess = { result ->
                                val products = result.data?.cashAssist?.listProducts?.items ?: listOf()
                                saveCachedProductCategoriesUseCase(products)

                                _state.value = _state.value.copy(
                                    allProducts = products
                                )
                            }
                        )
                    }
                } else {
                    _state.value = _state.value.copy(
                        allProducts = it
                    )
                }
            }
        }
    }

    private fun deleteTag(id: String) {
        launch {
            requestHandler(
                loadingState = { isLoading ->
                    _state.value = _state.value.copy(editTagLoading = isLoading)
                },
                callRequest = {
                    deleteTagUseCase(id = id)
                },
                onSuccess = { result ->
                    val newTags: MutableList<MediaTag>? = _state.value.mediaTags?.toMutableList()
                    val deletedPosition = newTags?.indexOfFirst { it.id == id }

                    if (deletedPosition != null && deletedPosition >= 0) {
                        newTags.removeAt(deletedPosition)
                    }

                    _state.value = _state.value.copy(
                        mediaTags = newTags
                    )
                },
                onError = { result ->
                    showRequestError(result.errors)
                },
                onException = { e ->
                    showException(e)
                }
            )
        }
    }

    private fun addTag(name: String) {
        launch {
            requestHandler(
                loadingState = { isLoading ->
                    _state.value = _state.value.copy(editTagLoading = isLoading)
                },
                callRequest = {
                    addTagUseCase(name = name)
                },
                onSuccess = { result ->
                    if (result.data?.cashAssist?.createTag != null) {
                        getMediaTags()
                    }
                },
                onError = { result ->
                    showRequestError(result.errors)
                },
                onException = { e ->
                    showException(e)
                }
            )
        }
    }

    private fun loadAppConstants() {
        launch {
            requestHandler(
                callRequest = {
                    loadAppConstantsUseCase(
                        type = IdUtils.animationAppConstantsType,
                        language = "German" //TODO (Must be fixed)
                    )
                },
                onSuccess = { result ->
                    _state.value = _state.value.copy(
                        animationType = result.data?.cashAssist?.loadAppConstants
                    )
                }
            )
        }
    }

    private fun getShopList() {
        launch {
            requestHandler(
                callRequest = {
                    getSavedShopListUseCase()
                },
                onSuccess = { result ->
                    _state.value = _state.value.copy(
                        shopList = result?.data?.cashAssist?.listShops?.items
                    )
                },
                onError = { result ->
                    showRequestError(result?.errors)
                },
                onException = { e ->
                    showException(e)
                }
            )
        }
    }

    private fun getBase64Img(
        keyMedia169: String? = null,
        keyMedia: String? = null,
    ) {
        launch {
            requestHandler(
                loadingState = { isLoading ->
                    _state.value = _state.value.copy(isLoading = isLoading)
                },
                callRequest = {
                    val resultMedia = if (keyMedia != null) imgUrlUseCase(keyMedia) else null
                    val resultMedia169 = if (keyMedia169 != null) imgUrlUseCase(keyMedia169) else null
                    Pair(resultMedia, resultMedia169)
                },
                onSuccess = { (resultMedia, resultMedia169) ->
                    _state.value = _state.value.copy(
                        mediaImg = resultMedia,
                        mediaImg169 = resultMedia169
                    )
                },
                onException = { e ->
                    showException(e)
                }
            )
        }
    }

    private fun updateBase64Img(
        file: String,
        type: String,
        id: String
    ) {
        launch {
            requestHandler(
                loadingState = { isLoading ->
                    _state.value = _state.value.copy(isLoading = isLoading)
                },
                callRequest = {
                    updateBase64ImgUseCase(
                        file = file,
                        type = type,
                        id = id
                    )
                },
                onSuccess = { result ->
                    when (type) {
                        ApiUtils.Type.Media -> {
                            getBase64Img(keyMedia = result.data?.cashAssist?.img?.key)
                        }
                        ApiUtils.Type.Media9_16 -> {
                            getBase64Img(keyMedia169 = result.data?.cashAssist?.img?.key)
                        }
                    }
                },
                onError = { result ->
                    showRequestError(result.errors)
                },
                onException = { e ->
                    showException(e)
                }
            )
        }
    }

    private fun updateMedia(
        id: String,
        dataTitle: String,
        dataValue: dynamic,
        updateMediaType: String
    ) {
        launch {
            requestHandler(
                loadingState = { isLoading ->
                    _state.value = _state.value.copy(isLoading = isLoading)
                },
                callRequest = {
                    updateMediaUseCase(
                        id = id,
                        dataTitle = dataTitle,
                        dataValue = dataValue,
                        updateMediaType = updateMediaType
                    )
                },
                onSuccess = { result ->
                    _state.value = _state.value.copy(
                        selectedMedia = result.data?.cashAssist?.updateMedia
                    )
                },
                onError = { result ->
                    _state.value = _state.value.copy(
                        selectedMedia = state.value.selectedMedia
                    )
                    showRequestError(result.errors)
                },
                onException = { e ->
                    _state.value = _state.value.copy(
                        selectedMedia = state.value.selectedMedia
                    )
                    showException(e)
                }
            )
        }
    }

    private fun getMediaTags() {
        launch {
            requestHandler(
                callRequest = {
                    mediaTagsUseCase()
                },
                onSuccess = { result ->
                    _state.value = _state.value.copy(
                        mediaTags = result.data?.cashAssist?.listTags
                    )
                },
                onError = { result ->
                    showRequestError(result.errors)
                },
                onException = { e ->
                    showException(e)
                }
            )
        }
    }

    private fun onSubmitRecordDialogClick(
        name: String,
        windowMode: WindowSizeModeEnum
    ) {
        launch {
            requestHandler(
                loadingState = { isLoading ->
                    _state.value = _state.value.copy(addRecordLoading = isLoading)
                },
                callRequest = {
                    addNewMediaUseCase(name = name)
                },
                onSuccess = { model ->
                    _state.value = _state.value.copy(
                        showAddRecordDialog = false,
                        addRecordErrorMessage = "",
                        newRecordName = "",
                        firstPageActive = windowMode != WindowSizeModeEnum.PHONE,
                        selectedMedia = model.data?.cashAssist?.createMedia
                    )
                    getMediaList(isActive = state.value.mediaItemsIsActiveFilter)
                },
                onError = { result ->
                    _state.value = _state.value.copy(
                        addRecordErrorMessage = "Error occurred"
                    )
                    showRequestError(result.errors)
                },
                onException = { e ->
                    _state.value = _state.value.copy(
                        addRecordErrorMessage = e.message.toString()
                    )
                    showException(e)
                }
            )
        }
    }

    private fun getMediaList(isActive: Boolean?) {
        launch {
            requestHandler(
                loadingState = { isLoading ->
                    _state.value = _state.value.copy(isLoading = isLoading)
                },
                callRequest = {
                    mediaListUseCase(isActive = isActive)
                },
                onSuccess = { result ->
                    val items = result.data?.cashAssist?.listMedia?.items ?: listOf()
                    _state.value = _state.value.copy(
                        mediaItems = items
                    )
                    tempMediaItems = items

                    if (!state.value.mediaItems.isNullOrEmpty() && state.value.selectedMedia == null) {
                        onMediaItemClick(
                            id = state.value.mediaItems?.get(0)?.id ?: ""
                        )
                    }
                },
                onError = { result ->
                    showRequestError(result.errors)
                },
                onException = { e ->
                    showException(e)
                }
            )
        }
    }

    private fun onMediaItemClick(
        id: String,
        switchTheSecondPage: () -> Unit = {}
    ) {
        if (id != state.value.selectedMedia?.id) {
            launch {
                requestHandler(
                    loadingState = { isLoading ->
                        _state.value = _state.value.copy(isLoading = isLoading)
                    },
                    callRequest = {
                        mediaDetailUseCase(id = id)
                    },
                    onSuccess = { result ->
                        val media = result.data?.cashAssist?.getMedia
                        _state.value = _state.value.copy(
                            selectedMedia = media
                        )
                        getBase64Img(
                            keyMedia = media?.img?.key,
                            keyMedia169 = media?.img169?.key
                        )
                        switchTheSecondPage()
                    },
                    onError = { result ->
                        showRequestError(result.errors)
                    },
                    onException = { e ->
                        showException(e)
                    }
                )
            }
        } else {
            switchTheSecondPage()
        }
    }


    private fun setToCalendarStatus(status: Boolean) {
        _state.value=_state.value.copy(
            showToCalendar = status
        )
    }

    private fun selectToDate(
        selectedDate:MonthModel
    ) {
        _state.value=_state.value.copy(
            showToCalendar = false,
            selectedToDate = selectedDate,
        )
        val json= buildJsonObject {
            put(ApiUtils.Field.to , monthModelToDateString(state.value.selectedToDate))
        }
        updateMedia(
            id = state.value.selectedMedia?.id?:"",
            dataTitle = ApiUtils.Field.dateInterval ,
            dataValue = json,
            updateMediaType = ApiUtils.Field.updateMediaMain,
        )
    }

    private fun setFromCalendarStatus(status:Boolean) {
        _state.value=_state.value.copy(
            showFromCalendar = status
        )
    }

    private fun selectFromDate(
        selectedDate:MonthModel
    ) {
        _state.value = _state.value.copy(
            showFromCalendar = false,
            selectedFromDate =  selectedDate,
        )
        val json= buildJsonObject {
            put(ApiUtils.Field.from , monthModelToDateString(state.value.selectedFromDate))
        }


        updateMedia(
            id = state.value.selectedMedia?.id?:"",
            dataTitle = ApiUtils.Field.dateInterval ,
            dataValue = json,
            updateMediaType = ApiUtils.Field.updateMediaMain,
        )


    }


    private fun onAddRecordIconClick() {
        _state.value=_state.value.copy(
            showAddRecordDialog = true
        )
    }

    private fun dismissAddRecordDialog() {
        _state.value=_state.value.copy(
            showAddRecordDialog = false,
            addRecordErrorMessage ="",
            newRecordName = "",
            addRecordLoading=false,
        )
        addNewMediaUseCase.cancel()
    }
    private fun onChangeRecordName(value: String) {
        _state.value=_state.value.copy(
            newRecordName = value
        )
        checkAddRecordSubmitClickable()
    }

    private fun checkAddRecordSubmitClickable(){
        if (state.value.newRecordName.isNotEmpty()){
            _state.value=_state.value.copy(
                isAddNewRecordSubmitClickable = true
            )
        }else _state.value=_state.value.copy(
            isAddNewRecordSubmitClickable = false
        )
    }

    private fun onMainGridNumberSortClick() {
        val newData:List<MediaItem>
        if (_state.value.isMainGridNumberSortedAsc) {
            newData=_state.value.mediaItems?.sortedByDescending { it.timeInterval?.from }?: listOf()
        }else{
            newData=_state.value.mediaItems?.sortedBy { it.timeInterval?.from }?.toList()?: listOf()
        }
        _state.value=_state.value.copy(
            mediaItems = newData,
            isMainGridNumberSortedAsc =!_state.value.isMainGridNumberSortedAsc,
            showMainGridNumberSortIcon = true,
            showMainGridNameSortIcon = false
        )
    }

    private fun onMainGridTitleSortClick() {
        val newData:List<MediaItem>
        if (_state.value.isMainGridNameSortedAsc) {
            newData=_state.value.mediaItems?.sortedByDescending { it.name?.lowercase() }?: listOf()
        }else{
            newData=_state.value.mediaItems?.sortedBy { it.name?.lowercase() }?.toList()?: listOf()
        }
        _state.value=_state.value.copy(
            mediaItems = newData,
            isMainGridNameSortedAsc =!_state.value.isMainGridNameSortedAsc,
            showMainGridNameSortIcon = true,
            showMainGridNumberSortIcon = false
        )
    }


    private fun onSearchMediaInputChange(value: String) {
        _state.value=_state.value.copy(
            mediaItems = tempMediaItems
        )

        val newData=_state.value.mediaItems?.filter {model ->
            (
                    model.name?.contains(value, ignoreCase = true) == true ||
                            model.timeInterval?.from?.contains(value, ignoreCase = true) == true
                    )
        }
        _state.value=_state.value.copy(
            mediaItems = newData
        )

    }



    private fun onTopTabClick(tab: MediaCenterInfoHeaderEnum) {
        _state.value=_state.value.copy(
            selectedTab = tab
        )
    }

    private fun getCheckoutData(  ) {
        launch {
            if (state.value.cashList==null){

                val result=getSavedCheckOutUseCase()

                _state.value=_state.value.copy(
                    cashList = result?.data?.cashAssist?.children
                )
                tempCheckoutList=state.value.cashList
            }

        }

    }

    private fun showRequestError(result:List<GeneralError?>?) {
        _state.value = _state.value.copy(
            errorInfo = errorMessage(result)
        )
    }
    private fun showException(e: Exception) {
        if (!e.toString().contains(ApiUtils.Status.ERR_401)){
            _state.value = _state.value.copy(
                errorInfo = e.message.toString()
            )
        }

    }

}